<!-- ===== HEADER ===== -->
<header class="landing-header landing-header--static">
	<div class="container d-flex align-items-center justify-content-between py-3 mh-landing-aic-header">
		<div class="d-flex align-items-center gap-3">
			<a href="/landing-page-aic" class="d-flex align-items-center text-decoration-none">
				<img src="/assets/images/PIB Italia Broker_logo.png" alt="PIB Italia broker" class="landing-logo-xl" />
			</a>
			<span class="landing-header-divider">|</span>
			<div class="d-flex align-items-center gap-2">
				<span class="landing-footer-powered" style="color: rgba(0,0,0,0.35);">IN PARTNERSHIP WITH</span>
				<img src="/assets/img/aic/logo.png" alt="AIC" class="landing-logo-aic" />
			</div>
		</div>
		<div class="d-flex align-items-center gap-3">
			<button
				class="d-md-none btn p-1 border-0 bg-transparent"
				type="button"
				(click)="mobileNavOpen = !mobileNavOpen"
				[attr.aria-expanded]="mobileNavOpen"
				[attr.aria-label]="'Apri menu' | translate">
				<i class="bi fs-3" [class.bi-list]="!mobileNavOpen" [class.bi-x]="mobileNavOpen" style="color: var(--color-dark)"></i>
			</button>
		</div>
	</div>
	@if (mobileNavOpen) {
		<div class="border-top container py-2">
			<a
				class="landing-nav-link d-block py-2"
				(click)="scrollTo('coperture'); mobileNavOpen = false"
				(keydown.enter)="scrollTo('coperture'); mobileNavOpen = false"
				role="button"
				tabindex="0">
				{{'Coperture' | translate}}
			</a>
			<a
				class="landing-nav-link d-block py-2"
				(click)="scrollTo('come-funziona'); mobileNavOpen = false"
				(keydown.enter)="scrollTo('come-funziona'); mobileNavOpen = false"
				role="button"
				tabindex="0">
				{{'Come funziona' | translate}}
			</a>
			<a
				class="landing-nav-link d-block py-2"
				(click)="scrollTo('perche-aic'); mobileNavOpen = false"
				(keydown.enter)="scrollTo('perche-aic'); mobileNavOpen = false"
				role="button"
				tabindex="0">
				{{'aicNavPerche' | translate}}
			</a>
			<a
				class="landing-nav-link d-block py-2"
				(click)="scrollTo('chi-siamo'); mobileNavOpen = false"
				(keydown.enter)="scrollTo('chi-siamo'); mobileNavOpen = false"
				role="button"
				tabindex="0">
				{{'Chi siamo' | translate}}
			</a>
			<a class="landing-nav-link d-block py-2" (click)="scrollTo('faq'); mobileNavOpen = false" (keydown.enter)="scrollTo('faq'); mobileNavOpen = false" role="button" tabindex="0">
				FAQ
			</a>
			<div class="d-flex align-items-center py-3 border-top mt-1">
				<app-change-language class="select-not-bordered"></app-change-language>
			</div>
		</div>
	}
</header>

<!-- ===== NAV BAR ===== -->
<nav class="landing-navbar d-none d-md-block">
	<div class="container d-flex align-items-center justify-content-between">
		<div class="d-none d-md-flex align-items-center">
			<a class="landing-navbar-link" (click)="scrollTo('coperture')" role="button" tabindex="0" (keydown.enter)="scrollTo('coperture')">{{'Coperture' | translate | uppercase}}</a>
			<a class="landing-navbar-link" (click)="scrollTo('come-funziona')" role="button" tabindex="0" (keydown.enter)="scrollTo('come-funziona')">
				{{'Come funziona' | translate | uppercase}}
			</a>
			<a class="landing-navbar-link" (click)="scrollTo('perche-aic')" role="button" tabindex="0" (keydown.enter)="scrollTo('perche-aic')">
				{{'aicNavPerche' | translate | uppercase}}
			</a>
			<a class="landing-navbar-link" (click)="scrollTo('chi-siamo')" role="button" tabindex="0" (keydown.enter)="scrollTo('chi-siamo')">{{'Chi siamo' | translate | uppercase}}</a>
			<a class="landing-navbar-link" (click)="scrollTo('faq')" role="button" tabindex="0" (keydown.enter)="scrollTo('faq')">FAQ</a>
		</div>
		<div class="d-flex align-items-center gap-3">
			<app-change-language class="select-not-bordered select-transparent"></app-change-language>
		</div>
	</div>
</nav>

<!-- ===== HERO ===== -->
<section class="landing-hero">
	<div class="landing-hero-overlay"></div>
	<div class="container position-relative z-2 py-5">
		<div class="row">
			<div class="col-12 col-md-6">
				<div class="min-vh-hero d-flex flex-column justify-content-center">
					<span class="landing-hero-eyebrow mb-3">{{'aicHeroEyebrow' | translate}}</span>
					<h1 class="landing-hero-title fw-bold mb-4">
						{{'aicHeroTitle1' | translate}}
						<br />
						{{'aicHeroTitle2' | translate}}
					</h1>
					<p class="landing-hero-subtitle mb-5">
						{{'aicHeroSubtitle1' | translate}}
						<br />
						{{'Coperture' | translate}}
						<strong>{{'aicHeroSubtitleBold' | translate}}</strong>
					</p>
					<div class="d-flex flex-column align-items-start flex-sm-row gap-3">
						<button class="btn landing-btn-light fw-bold px-4 py-2" (click)="calcolaPreventivo()">{{'aicHeroBtn' | translate}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- ===== COPERTURE ===== -->
<section class="landing-section landing-section-light" id="coperture">
	<div class="container">
		<div class="text-center mb-5">
			<span class="landing-eyebrow mb-2">{{'Le nostre coperture' | translate}}</span>
			<h2 class="landing-section-title fw-bold mt-2">{{'aicCopertureTitle' | translate}}</h2>
		</div>
		<div class="row justify-content-center g-4">
			@if (gruppi.length > 0) {
				@for (gruppo of gruppi; track gruppo.idProductGroup; let i = $index) {
					<div class="col-12 col-md-4">
						<div class="landing-card h-100" (click)="selezionaGruppo(gruppo)" (keydown.enter)="selezionaGruppo(gruppo)" role="button" tabindex="0">
							<div class="landing-card-number">0{{ i + 1 }}</div>
							<h3 class="landing-card-title text-capitalize mt-3 mt-md-0">{{ gruppo.titleLanguage }}</h3>
							<div class="product-description landing-card-description" [innerHTML]="gruppo.descriptionLanguage | descriptionLines"></div>
							<hr class="landing-card-divider" />
							<button class="btn landing-btn-primary w-100 fw-bold mt-auto" (click)="selezionaGruppo(gruppo); $event.stopPropagation()">
								{{'Seleziona' | translate | uppercase}}
							</button>
						</div>
					</div>
				}
			} @else {
				<div class="col-12 text-center py-5">
					<div class="spinner-border" style="color: var(--color-primary);" role="status"></div>
					<p class="mt-3 text-muted">{{'Caricamento coperture in corso...' | translate}}</p>
				</div>
			}
		</div>
	</div>
</section>

<!-- ===== COME FUNZIONA ===== -->
<section class="landing-section landing-section-dark" id="come-funziona">
	<div class="container">
		<div class="text-center mb-5">
			<span class="landing-eyebrow-light mb-2">{{'Semplice e veloce' | translate}}</span>
			<h2 class="landing-section-title-light fw-bold mt-2">{{'Come funziona' | translate}}</h2>
		</div>
		<div class="row justify-content-center g-4">
			<div class="col-12 col-md-4 text-center">
				<div class="landing-step">
					<div class="landing-step-number">01</div>
					<h4 class="landing-step-title mt-3">{{'aicStep1Title' | translate}}</h4>
					<p class="landing-step-description">{{'aicStep1Desc' | translate}}</p>
				</div>
			</div>
			<div class="col-12 col-md-4 text-center">
				<div class="landing-step">
					<div class="landing-step-number">02</div>
					<h4 class="landing-step-title mt-3">{{'Inserisci i tuoi dati' | translate}}</h4>
					<p class="landing-step-description">{{'aicStep2Desc' | translate}}</p>
				</div>
			</div>
			<div class="col-12 col-md-4 text-center">
				<div class="landing-step">
					<div class="landing-step-number">03</div>
					<h4 class="landing-step-title mt-3">{{'aicStep3Title' | translate}}</h4>
					<p class="landing-step-description">{{'aicStep3Desc' | translate}}</p>
				</div>
			</div>
		</div>
		<div class="row mt-5">
			<div class="col-12 text-center">
				<button class="btn landing-btn-light fw-bold px-5 py-3" (click)="calcolaPreventivo()">{{'aicIniziaOra' | translate}} &rsaquo;</button>
			</div>
		</div>
	</div>
</section>

<!-- ===== PERCHÉ PIB Group ===== -->
<section class="landing-section landing-section-grey" id="perche-aic">
	<div class="container">
		<div class="row mb-5">
			<div class="col-12 col-md-7">
				<span class="landing-eyebrow mb-2">{{'aicPercheEyebrow' | translate}}</span>
				<h2 class="landing-section-title fw-bold mt-2">
					{{'aicPercheTitle1' | translate}}
					<br />
					{{'aicPercheTitle2' | translate}}
				</h2>
			</div>
		</div>
		<div class="row g-4">
			<div class="col-12 col-md-4">
				<div class="py-2">
					<span class="landing-benefit-number">1.</span>
					<h4 class="landing-benefit-title">{{'aicBenefit1Title' | translate}}</h4>
					<p class="landing-benefit-description">{{'aicBenefit1Desc' | translate}}</p>
				</div>
			</div>
			<div class="col-12 col-md-4">
				<div class="py-2">
					<span class="landing-benefit-number">2.</span>
					<h4 class="landing-benefit-title">{{'Condizioni chiare' | translate}}</h4>
					<p class="landing-benefit-description">{{'aicBenefit2Desc' | translate}}</p>
				</div>
			</div>
			<div class="col-12 col-md-4">
				<div class="py-2">
					<span class="landing-benefit-number">3.</span>
					<h4 class="landing-benefit-title">{{'aicBenefit3Title' | translate}}</h4>
					<p class="landing-benefit-description">{{'aicBenefit3Desc' | translate}}</p>
				</div>
			</div>
			<div class="col-12 col-md-4">
				<div class="py-2">
					<span class="landing-benefit-number">4.</span>
					<h4 class="landing-benefit-title">{{'aicBenefit4Title' | translate}}</h4>
					<p class="landing-benefit-description">{{'aicBenefit4Desc' | translate}}</p>
				</div>
			</div>
			<div class="col-12 col-md-4">
				<div class="py-2">
					<span class="landing-benefit-number">5.</span>
					<h4 class="landing-benefit-title">{{'aicBenefit5Title' | translate}}</h4>
					<p class="landing-benefit-description">{{'aicBenefit5Desc' | translate}}</p>
				</div>
			</div>
			<div class="col-12 col-md-4">
				<div class="py-2">
					<span class="landing-benefit-number">6.</span>
					<h4 class="landing-benefit-title">{{'aicBenefit6Title' | translate}}</h4>
					<p class="landing-benefit-description">{{'aicBenefit6Desc' | translate}}</p>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- ===== CHI SIAMO ===== -->
<section class="landing-section landing-section-light" id="chi-siamo">
	<div class="container">
		<div class="row align-items-center g-4">
			<div class="col-12 col-md-6">
				<span class="landing-eyebrow mb-2">{{'Chi siamo' | translate}}</span>
				<h2 class="landing-section-title fw-bold mt-2">PIB Italia Broker</h2>
				<p class="landing-text mt-4">
					{{'aicChiSiamoText1Pre' | translate}}
					<strong>{{'aicChiSiamoText1Bold' | translate}}</strong>
					{{'aicChiSiamoText1Post' | translate}}
				</p>
				<p class="landing-text mt-3">
					{{'aicChiSiamoText2Pre' | translate}}
					<strong>AIC</strong>
					{{'aicChiSiamoText2Post' | translate}}
				</p>
				<button class="btn landing-btn-primary fw-bold px-4 py-2 mt-4" (click)="calcolaPreventivo()">{{'aicProteggitiOra' | translate}} &rsaquo;</button>
			</div>
			<div class="col-12 col-md-6">
				<div class="row g-3">
					<div class="col-12">
						<div class="landing-info-card">
							<div class="d-flex gap-3 align-items-start">
								<div class="landing-info-icon"><i class="bi bi-circle-fill"></i></div>
								<p class="landing-text mb-0">
									{{'aicInfoCard1Pre' | translate}}
									<strong>{{'aicInfoCard1Bold' | translate}}</strong>
									{{'aicInfoCard1Post' | translate}}
								</p>
							</div>
						</div>
					</div>
					<div class="col-12">
						<div class="landing-info-card">
							<div class="d-flex gap-3 align-items-start">
								<div class="landing-info-icon"><i class="bi bi-circle-fill"></i></div>
								<p class="landing-text mb-0">
									{{'aicInfoCard2Pre' | translate}}
									<strong>{{'aicInfoCard2Bold' | translate}}</strong>
									{{'aicInfoCard2Post' | translate}}
								</p>
							</div>
						</div>
					</div>
					<div class="col-12">
						<div class="landing-info-card">
							<div class="d-flex gap-3 align-items-start">
								<div class="landing-info-icon"><i class="bi bi-circle-fill"></i></div>
								<p class="landing-text mb-0">
									{{'aicInfoCard3Pre' | translate}}
									<strong>{{'aicInfoCard3Bold' | translate}}</strong>
									{{'aicInfoCard3Post' | translate}}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- ===== FAQ ===== -->
<section class="landing-section landing-section-grey" id="faq">
	<div class="container">
		<div class="row justify-content-center mb-5">
			<div class="col-12 col-md-8 text-center">
				<span class="landing-eyebrow mb-2">{{'Hai domande?' | translate}}</span>
				<h2 class="landing-section-title fw-bold mt-2">{{'Domande frequenti' | translate}}</h2>
			</div>
		</div>
		<div class="col-12 col-md-8 mx-auto">
			<div class="accordion accordion-flush" id="aic-faq">
				<div class="accordion-item landing-accordion-item">
					<h2 class="accordion-header">
						<button
							#accordionButton
							class="accordion-button collapsed landing-accordion-btn"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#aic-faq-1"
							aria-expanded="false">
							<span class="landing-faq-number">1</span>
							{{'aicFaq1Q' | translate}}
							<i class="bi bi-plus faq-icon ms-auto"></i>
						</button>
					</h2>
					<div id="aic-faq-1" class="accordion-collapse collapse" data-bs-parent="#aic-faq">
						<div class="accordion-body landing-accordion-body">{{'aicFaq1A' | translate}}</div>
					</div>
				</div>
				<div class="accordion-item landing-accordion-item">
					<h2 class="accordion-header">
						<button
							#accordionButton
							class="accordion-button collapsed landing-accordion-btn"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#aic-faq-3"
							aria-expanded="false">
							<span class="landing-faq-number">2</span>
							{{'aicFaq2Q' | translate}}
							<i class="bi bi-plus faq-icon ms-auto"></i>
						</button>
					</h2>
					<div id="aic-faq-3" class="accordion-collapse collapse" data-bs-parent="#aic-faq">
						<div class="accordion-body landing-accordion-body">{{'aicFaq2A' | translate}}</div>
					</div>
				</div>
				<div class="accordion-item landing-accordion-item">
					<h2 class="accordion-header">
						<button
							#accordionButton
							class="accordion-button collapsed landing-accordion-btn"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#aic-faq-4"
							aria-expanded="false">
							<span class="landing-faq-number">3</span>
							{{'aicFaq3Q' | translate}}
							<i class="bi bi-plus faq-icon ms-auto"></i>
						</button>
					</h2>
					<div id="aic-faq-4" class="accordion-collapse collapse" data-bs-parent="#aic-faq">
						<div class="accordion-body landing-accordion-body">{{'aicFaq3A' | translate}}</div>
					</div>
				</div>
				<div class="accordion-item landing-accordion-item">
					<h2 class="accordion-header">
						<button
							#accordionButton
							class="accordion-button collapsed landing-accordion-btn"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#aic-faq-5"
							aria-expanded="false">
							<span class="landing-faq-number">4</span>
							{{'aicFaq4Q' | translate}}
							<i class="bi bi-plus faq-icon ms-auto"></i>
						</button>
					</h2>
					<div id="aic-faq-5" class="accordion-collapse collapse" data-bs-parent="#aic-faq">
						<div class="accordion-body landing-accordion-body">{{'aicFaq4A' | translate}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- ===== CTA FINALE ===== -->
<section class="landing-cta py-5">
	<div class="container py-3">
		<div class="row justify-content-center text-center">
			<div class="col-12 col-md-8">
				<h2 class="landing-cta-title fw-bold mb-3">{{'aicCtaTitolo' | translate}}</h2>
				<p class="landing-cta-subtitle mb-5">{{'aicCtaSottotitolo' | translate}}</p>
				<button class="btn landing-btn-light fw-bold px-5 py-3" (click)="calcolaPreventivo()">{{'aicCalcolaTuoPreventivo' | translate}} &rsaquo;</button>
			</div>
		</div>
	</div>
</section>

<!-- ===== FOOTER ===== -->
<footer class="landing-footer aic">
	<div class="container">
		<div class="row align-items-center py-2">
			<div class="col-12 col-md-4 text-center text-md-start mb-3 mb-md-0">
				<div class="d-flex align-items-center justify-content-center justify-content-md-start gap-3">
					<img src="/assets/images/pib italia broker logo bianco.png" alt="PIB Italia broker" class="landing-logo-xl" />
					<span class="landing-footer-divider">|</span>
					<div class="d-flex align-items-center gap-2">
						<span class="landing-footer-powered">IN PARTNERSHIP WITH</span>
						<img src="/assets/img/aic/logo.png" alt="AIC" class="landing-logo-md landing-logo-circle bg-white p-2" />
					</div>
				</div>
			</div>
			<div class="col-12 col-md-4 text-center mb-3 mb-md-0">
				<div class="d-flex justify-content-center gap-4">
					<a class="landing-footer-link" (click)="scrollTo('coperture')" role="button" tabindex="0" (keydown.enter)="scrollTo('coperture')">{{'Coperture' | translate}}</a>
					<a class="landing-footer-link" (click)="scrollTo('chi-siamo')" role="button" tabindex="0" (keydown.enter)="scrollTo('chi-siamo')">{{'Chi siamo' | translate}}</a>
					<a class="landing-footer-link" (click)="scrollTo('faq')" role="button" tabindex="0" (keydown.enter)="scrollTo('faq')">FAQ</a>
				</div>
			</div>
			<div class="col-12 col-md-4 text-center text-md-end">
				<span class="landing-footer-copy">{{'aicFooterCopy' | translate}}</span>
			</div>
		</div>
		<div class="row">
			<div class="col-4"></div>
			<div class="col-4 text-center mt-2">
				<span class="landing-footer-copy" style="font-size: 11px;">
					{{'Illustrations by' | translate}}
					<a href="https://storyset.com" target="_blank" rel="noopener" class="landing-footer-link">Storyset</a>
				</span>
			</div>
			<div class="col-12 col-md-4 text-center text-md-end mt-2">
				<span class="landing-footer-copy d-block">{{'aicFooterRui' | translate}}</span>
				<span class="landing-footer-copy d-block">{{'aicFooterIvass' | translate}}</span>
			</div>
		</div>
	</div>
</footer>

<button class="scroll-to-top" [class.scroll-to-top--visible]="showScrollTop" (click)="scrollToTop()" [attr.aria-label]="'Torna in cima' | translate">
	<i class="bi bi-arrow-up"></i>
</button>
